import { Switch, Route, Redirect, matchPath, useHistory, withRouter } from 'react-router-dom'
import React, { useEffect, useMemo, useState } from 'react'
import { Home } from 'app/layout/home'

import ErrorPage from './error-page'
import { PrivateRoute } from '.'

import UserLogin from 'app/users/login/user-login'
import TwoFaUserLogin from 'app/users/two-fa-login/two-fa-user-login'
import { RequireUserContextProvider } from 'app/shared/state/require-user-context'
import { useUserContext } from 'app/shared/state/user-context'
import ForgotPassword from 'app/users/forgot-password/forgot-password'
import SetPassword from 'app/users/set-password/set-password'
import { useAppContext } from 'app/app-context/app-context'

const Communities = React.lazy(() => import('app/communities/communities'))
const Users = React.lazy(() => import('app/users'))
const Services = React.lazy(() => import('app/services/services'))

const Routes = () => {
  const { currentUser, loadingCurrentUser } = useUserContext()
  const { setCurrentCommunity, setCurrentCompany } = useAppContext()

  const history = useHistory()

  const [currentPathname, setCurrentPathname] = useState(history.location.pathname)

  history.listen((location, action) => {
    if (location.pathname !== currentPathname) {
      setCurrentPathname(location.pathname)
    }
  })

  const isInCommunityRoute = useMemo(() => {
    return matchPath(currentPathname, '/communities/:communityId') != null
  }, [currentPathname])

  const isInCompanyRoute = useMemo(() => {
    return matchPath(currentPathname, '/communities/:communityId/companies/:companyId') != null
  }, [currentPathname])

  useEffect(() => {
    if (!isInCommunityRoute) {
      setCurrentCommunity(undefined)
    }
  }, [isInCommunityRoute, setCurrentCommunity])

  useEffect(() => {
    if (!isInCompanyRoute) {
      setCurrentCompany(undefined)
    }
  }, [isInCompanyRoute, setCurrentCompany])

  if (loadingCurrentUser) {
    return (
      <div
        style={{
          display: 'flex',
          color: 'white',
          width: '100%',
          height: '50vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        Bezig met laden...
      </div>
    )
  }

  if (!currentUser) {
    return (
      <Switch>
        <Route exact path="/login" component={UserLogin} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route path="/set-password" component={SetPassword} />
        <Route path="/activate-user" component={SetPassword} />
        <Route exact path="/two-fa-login" component={TwoFaUserLogin} />
        <Route exact path="/error" component={ErrorPage} />
        <Route>
          <Redirect to="/login" />
        </Route>
      </Switch>
    )
  }

  return (
    <Switch>
      <RequireUserContextProvider>
        <PrivateRoute exact path="/">
          <Home hostname={process.env.REACT_APP_OVERRIDE_HOST || window.location.host} />
        </PrivateRoute>

        <PrivateRoute path="/communities">
          <Communities mountPath="/communities" />
        </PrivateRoute>

        <PrivateRoute path="/services">
          <Services mountPath="/services" />
        </PrivateRoute>

        <PrivateRoute path="/users">
          <Users mountPath="/users" />
        </PrivateRoute>
      </RequireUserContextProvider>
      <Route exact path="/error" component={ErrorPage} />
    </Switch>
  )
}

export default withRouter(Routes)
